"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { Suspense } from "react";
import { FeaturedCollectionSlide } from "../FeaturedCollectionSlide";
import { FeaturedCollectionSlideFragment } from "../FeaturedCollectionSlide/FeaturedCollectionSlide.fragment";
import { FeaturedCollectionsCarouselSkeleton } from "./FeaturedCollectionsCarouselSkeleton";
const query = graphql(`
    query FeaturedCollectionsCarouselLayoutQuery($slugs: [String!]!) {
      collectionsBySlugs(slugs: $slugs) {
        __typename
        ... on Collection {
          slug
        }
        ... on DelistedCollection {
          slug
        }
        ... on BlacklistedCollection {
          slug
        }
        ...CollectionOverviewFeaturedCollectionSlide
      }
    }
  `, [FeaturedCollectionSlideFragment]);
function BaseFeaturedCollectionsCarouselLayout(t0) {
  const $ = _c(7);
  const {
    slugs
  } = t0;
  let t1;
  if ($[0] !== slugs) {
    t1 = {
      slugs
    };
    $[0] = slugs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !slugs.length;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      query,
      variables: t1,
      pause: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const [t4] = useQuery(t3);
  const {
    data
  } = t4;
  let t5;
  if ($[5] !== data?.collectionsBySlugs) {
    t5 = data?.collectionsBySlugs.map(_temp);
    $[5] = data?.collectionsBySlugs;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
function _temp(collection) {
  if (collection.__typename === "DelistedCollection") {
    return null;
  }
  if (collection.__typename === "BlacklistedCollection") {
    return null;
  }
  return <FeaturedCollectionSlide collection={collection} key={collection.slug} />;
}
export function FeaturedCollectionsCarouselLayout(t0) {
  const $ = _c(9);
  const {
    sections
  } = t0;
  let t1;
  if ($[0] !== sections) {
    t1 = sections?.flatMap(_temp2) ?? [];
    $[0] = sections;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const slugs = t1;
  let t2;
  if ($[2] !== slugs.length) {
    t2 = <FeaturedCollectionsCarouselSkeleton slides={slugs.length} />;
    $[2] = slugs.length;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== slugs) {
    t3 = <BaseFeaturedCollectionsCarouselLayout slugs={slugs} />;
    $[4] = slugs;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <Suspense fallback={t2}>{t3}</Suspense>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp2(collection) {
  return collection?.__typename === "FeatureContentBlock" && collection.collectionSlug ? [collection.collectionSlug] : [];
}